import angular from 'angular';
import '../core.module';
import { derivePermissions } from '../helpers/permission-mapper.helper';

class AuthService {
  constructor($http, API_BASE_URL, SessionService, ThemeService) {
    this.$http = $http;
    this.API_BASE_URL = API_BASE_URL;
    this.SessionService = SessionService;
    this.ThemeService = ThemeService;
  }

  captchaSettings() {
    return this.$http.get(`${this.API_BASE_URL}/auth/captcha`).then((response) => response.data);
  }

  login(email, password, tenantSlug, captchaToken) {
    const credentials = { email, password };
    if (tenantSlug && tenantSlug.trim()) credentials.tenantSlug = tenantSlug.trim();
    if (captchaToken) credentials.captchaToken = captchaToken;
    return this.$http.post(`${this.API_BASE_URL}/auth/login`, credentials).then((response) => {
      const { accessToken, refreshToken } = response.data;
      const slug = response.data.tenantSlug || credentials.tenantSlug;
      this.SessionService.setSession({}, accessToken, refreshToken, slug);
      return this.fetchProfile();
    });
  }

  fetchProfile() {
    return this.$http.get(`${this.API_BASE_URL}/users/me`).then((response) => {
      const profile = response.data;
      const preferences = profile.ui_preferences || {};
      if (preferences.theme) this.ThemeService.applySaved(preferences.theme);
      const user = {
        id: profile.id,
        name: profile.name,
        email: profile.email,
        avatar: null,
        role: profile.roleSlugs[0] || 'agent',
        mustChangePassword: Boolean(profile.must_change_password),
        preferences,
        permissions: [
          ...derivePermissions(profile.permissionSlugs || []),
          ...(profile.permissionSlugs || [])
        ]
      };
      this.SessionService.setSession(
        user,
        this.SessionService.token,
        this.SessionService.refreshToken,
        this.SessionService.tenantSlug
      );
      return this.SessionService.user;
    });
  }

  changePassword(currentPassword, newPassword) {
    return this.$http.post(`${this.API_BASE_URL}/auth/change-password`, {
      currentPassword,
      newPassword
    });
  }

  logout() {
    return this.$http.post(`${this.API_BASE_URL}/auth/logout`, {}).finally(() => {
      this.SessionService.clearSession();
    });
  }
}

AuthService.$inject = ['$http', 'API_BASE_URL', 'SessionService', 'ThemeService'];

angular.module('app.core').service('AuthService', AuthService);

export default AuthService;
